module.exports = __webpack_public_path__ + "img/no-results.95f29722.svg";